// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1XWrz","copyright":"Footer_copyright__YJkZI"};